export default __webpack_public_path__ + "static/media/0xd978724d457f441603e550a8e0d59848515e21a2.17b22b1e.png";